import { createAction } from '@reduxjs/toolkit';

import { SurveyAnswer, SurveyDataProps } from './types';

export const setLoadingSurvey = createAction<boolean>(
  'set survey data loading',
);
export const setSurveyData = createAction<SurveyDataProps>('set survey data');
export const setSurveyAnswer = createAction<SurveyAnswer>('set survey answer');
export const setSurveySubmitted = createAction('set survey submitted');
export const setActiveStep = createAction<number>('set survey active step');
